import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { api } from '@/services/api';
import { newsApi } from '@/services/newsApi';
import { avatarApi } from '@/services/avatarApi';
import { customizationApi } from '@/services/customizationApi';
import { qriotsApi } from '@/services/qriotsApi';
import { qbotApi } from '@/services/qbotApi';
import { socialApi } from '@/services/socialApi';
import { qduelsApi } from '@/services/qduelsApi';
import { qchessApi } from '@/services/qchessApi';
import { qclansApi } from '@/services/qclansApi';
import { qbankApi } from '@/services/qbankApi';
import { qgammonApi } from '@/services/qgammonApi';
import { qchinesepokerApi } from '@/services/qchinesepokerApi';
import { questApi } from '@/services/questApi';
import { limuloApi } from '@/services/limuloApi';

import authReducer from './auth.slice';
import settingsReducer from './settings.slice';
import appearanceReducer from './appearance.slice';
import tournamentReducer from './tournament.slice';
import coreReducer from './core.slice';
import errorReducer from './error.slice';
import newsReducer from './news.slice';
import refetchReducer from './refetch.slice';
import unreadReducer from './unread.slice';
import engagementReducer from './engagement.slice';
import activeMatchReducer from './activeMatch.slice';

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    [newsApi.reducerPath]: newsApi.reducer,
    [avatarApi.reducerPath]: avatarApi.reducer,
    [customizationApi.reducerPath]: customizationApi.reducer,
    [qriotsApi.reducerPath]: qriotsApi.reducer,
    [qbotApi.reducerPath]: qbotApi.reducer,
    [socialApi.reducerPath]: socialApi.reducer,
    [qduelsApi.reducerPath]: qduelsApi.reducer,
    [qchessApi.reducerPath]: qchessApi.reducer,
    [qclansApi.reducerPath]: qclansApi.reducer,
    [qbankApi.reducerPath]: qbankApi.reducer,
    [qgammonApi.reducerPath]: qgammonApi.reducer,
    [qchinesepokerApi.reducerPath]: qchinesepokerApi.reducer,
    [questApi.reducerPath]: questApi.reducer,
    [limuloApi.reducerPath]: limuloApi.reducer,
    auth: authReducer,
    settings: settingsReducer,
    appearance: appearanceReducer,
    tournament: tournamentReducer,
    core: coreReducer,
    error: errorReducer,
    news: newsReducer,
    refetch: refetchReducer,
    unread: unreadReducer,
    engagement: engagementReducer,
    activeMatch: activeMatchReducer,
  },
  middleware: (getDefault) =>
    getDefault().concat(
      api.middleware,
      newsApi.middleware,
      avatarApi.middleware,
      customizationApi.middleware,
      qriotsApi.middleware,
      qbotApi.middleware,
      socialApi.middleware,
      qduelsApi.middleware,
      qchessApi.middleware,
      qclansApi.middleware,
      qbankApi.middleware,
      qgammonApi.middleware,
      qchinesepokerApi.middleware,
      questApi.middleware,
      limuloApi.middleware,
    ),
});

// Enable `refetchOnFocus` / `refetchOnReconnect` for all RTK Query endpoints.
// In the Telegram WebView the focus event fires when the user comes back to
// the Mini App after switching apps — perfect moment to grab fresh data.
setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
